import type { PatentProfileWithMatchedTechFeature } from '../types';

export interface UpdateNoveltySimilarListPayload {
    taskId: string;
    techFeatures: PatentProfileWithMatchedTechFeature[];
    isPatentConfirm?: boolean;
}
export interface GetFeatureComparisonPayload {
    task_id: string;
    patent_pns: string[];
    is_add_patent?: boolean;
    add_patent_selected?: boolean;
}

export interface NoveltySimilarRepository {
    updateNoveltySimilarList(payload: UpdateNoveltySimilarListPayload): Promise<PatentProfileWithMatchedTechFeature[]>;

    getFeatureComparison(payload: GetFeatureComparisonPayload): Promise<PatentProfileWithMatchedTechFeature[]>;
}

export const NoveltySimilarRepository = Symbol.for('NoveltySimilarRepository');
